import { useUiStore } from '../stores/uiStore';
import './CompactToggle.css';

export default function CompactToggle() {
  const { compactCards, toggleCompactCards } = useUiStore();

  return (
    <button
      className={`compact-toggle ${compactCards ? 'compact-on' : ''}`}
      onClick={toggleCompactCards}
      title={compactCards ? 'Expand cards' : 'Compact cards'}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        {compactCards ? (
          <>
            <rect x="2" y="2" width="12" height="5" rx="1" stroke="currentColor" strokeWidth="1.2" />
            <rect x="2" y="9" width="12" height="5" rx="1" stroke="currentColor" strokeWidth="1.2" />
          </>
        ) : (
          <>
            <rect x="2" y="1" width="12" height="3" rx="1" stroke="currentColor" strokeWidth="1.2" />
            <rect x="2" y="6.5" width="12" height="3" rx="1" stroke="currentColor" strokeWidth="1.2" />
            <rect x="2" y="12" width="12" height="3" rx="1" stroke="currentColor" strokeWidth="1.2" />
          </>
        )}
      </svg>
    </button>
  );
}
